import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  InputLabel,
  Paper,
} from '@material-ui/core';
import { 
  renderCheckbox,
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  NA_YES_NO,
  NO_YES,
  UNKNOWN_YES_NO,
} from '../../../../actions/action-constants';
class FormFieldsTabClientDetailsTabsClientConditions extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
            
              <Grid container spacing={3}>  
                <Grid item xs={12}>
                  <InputLabel>
                    Homeless in past 12 months or 12 months preceding incarceration
                  </InputLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clienthomelesshistory'
                      name='clienthomelesshistory'
                      objName='clienthomelesshistory'
                      label='History'
                      footerMessage=''
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clienthomelesscurrent'
                      name='clienthomelesscurrent'
                      objName='clienthomelesscurrent'
                      label='Current'
                      footerMessage=''
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clienthomelessna'
                      name='clienthomelessna'
                      objName='clienthomelessna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel>
                    Behavioral / Mental Health Issues
                  </InputLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='clientmentalhealthissueshistory'
                    name='clientmentalhealthissueshistory'
                    objName='clientmentalhealthissueshistory'
                    label='History'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='clientmentalhealthissuescurrent'
                    name='clientmentalhealthissuescurrent'
                    objName='clientmentalhealthissuescurrent'
                    label='Current'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clientmentalhealthissuesna'
                      name='clientmentalhealthissuesna'
                      objName='clientmentalhealthissuesna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel>
                    Substance Use Disorder
                  </InputLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='clientsubstanceusedisorderissueshistory'
                    name='clientsubstanceusedisorderissueshistory'
                    objName='clientsubstanceusedisorderissueshistory'
                    label='History'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='clientsubstanceusedisorderissuescurrent'
                    name='clientsubstanceusedisorderissuescurrent'
                    objName='clientsubstanceusedisorderissuescurrent'
                    label='Current'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clientsubstanceusedisorderissuesna'
                      name='clientsubstanceusedisorderissuesna'
                      objName='clientsubstanceusedisorderissuesna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel>
                    Co-occurring Disorders
                  </InputLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='clientcooccurringhistory'
                    name='clientcooccurringhistory'
                    objName='clientcooccurringhistory'
                    label='History'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='clientcooccurringcurrent' 
                    name='clientcooccurringcurrent'
                    objName='clientcooccurringcurrent'
                    label='Current'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clientcooccurringna'
                      name='clientcooccurringna'
                      objName='clientcooccurringna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12}>
                  <InputLabel>
                    Employed in past 12 months or 12 months preceding incarceration
                  </InputLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                      locked={this.props.locked}
                      component={renderCheckbox}
                      id='clientemployedduringpasthistory'
                      name='clientemployedduringpasthistory'
                      objName='clientemployedduringpasthistory'
                      label='History'
                      footerMessage=''
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                <Field
                      locked={this.props.locked}
                      component={renderCheckbox}
                      id='clientemployedduringpastcurrent'
                      name='clientemployedduringpastcurrent'
                      objName='clientemployedduringpastcurrent'
                      label='Current'
                      footerMessage=''
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='clientemployedduringpastna'
                      name='clientemployedduringpastna'
                      objName='clientemployedduringpastna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                                        ////  LOCATED IN BOTH TAB-CLIENT-CONDITIONS AND HERE SAME FIELD
                    autoFocus
                    required
                    locked={this.props.locked}
                    component={renderSelectField6}
                                          // dataArray={UNKNOWN_YES_NO}
                    dataArray={NA_YES_NO}
                    id='clientriskofvictimization' 
                    name='clientriskofvictimization'
                    label='Client Risk of Victimization'
                    footerMessage=''
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >Unknown</option>
                                                                                    <option value='1' >Yes</option>
                                                                                    <option value='2' >No</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    required
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='clientriskasperpetrator' 
                    name='clientriskasperpetrator'
                    label='Client Risk As Perpetrator'
                    footerMessage=''
                    dataArray={UNKNOWN_YES_NO}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >Unknown</option>
                                                                                    <option value='1' >Yes</option>
                                                                                    <option value='2' >No</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>
              
              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='clientprescribedmedications' 
                    name='clientprescribedmedications'
                    label="Prescribed Medications"
                    footerMessage=''
                    dataArray={NO_YES}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >No</option>
                                                                                    <option value='1' >Yes</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='clientmedicationsupplyprovided' 
                    name='clientmedicationsupplyprovided'
                    label="Medication Supply Provided With Client"
                    footerMessage=''
                    dataArray={NO_YES}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >No</option>
                                                                                    <option value='1' >Yes</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsTabClientDetailsTabsClientConditions.propTypes = {
  locked: PropTypes.bool,
}
export default FormFieldsTabClientDetailsTabsClientConditions;